import type { HighlightColor } from '@jobos/shared/types/job';

export const HIGHLIGHT_COLOR_MAP: Record<HighlightColor, { bg: string; hover: string; border: string }> = {
  yellow: { bg: '#FEF9C3', hover: '#FEF08A', border: '#CA8A04' },
  red:    { bg: '#FEE2E2', hover: '#FECACA', border: '#DC2626' },
  green:  { bg: '#DCFCE7', hover: '#BBF7D0', border: '#16A34A' },
  blue:   { bg: '#DBEAFE', hover: '#BFDBFE', border: '#2563EB' },
  purple: { bg: '#F3E8FF', hover: '#E9D5FF', border: '#9333EA' },
  orange: { bg: '#FFEDD5', hover: '#FED7AA', border: '#EA580C' },
};
